/** Root for Figma-exported marketing assets (see docs/marketing-assets.md). */
export const MARKETING_ASSET_ROOT = '/marketing'

export function marketingShowcaseSrc(slug: string): string {
  return `${MARKETING_ASSET_ROOT}/${slug}/showcase.png`
}

export function marketingHeroSrc(slug: string): string {
  return `${MARKETING_ASSET_ROOT}/${slug}/hero.svg`
}

export function portfolioIntelligenceBasketsSrc(): string {
  return `${MARKETING_ASSET_ROOT}/portfolio-intelligence/baskets.png`
}

function brokerageIconAssetSlug(slug: string, iconSlug?: string): string {
  return iconSlug ?? slug
}

export function brokerageIconSrc(slug: string, iconSlug?: string): string {
  const asset = brokerageIconAssetSlug(slug, iconSlug)
  return `${MARKETING_ASSET_ROOT}/brokerages/icons/${asset}.webp`
}

export function brokerageIconFallbackSrc(slug: string, iconSlug?: string): string {
  const asset = brokerageIconAssetSlug(slug, iconSlug)
  return `${MARKETING_ASSET_ROOT}/brokerages/icons/${asset}.svg`
}

/** Generic mark when a brokerage-specific asset is missing (Figma `274:30814` cards). */
export function brokerageIconPlaceholderSrc(): string {
  return `${MARKETING_ASSET_ROOT}/brokerages/icons/placeholder.svg`
}

export function ivyChatArrowUpIconSrc(): string {
  return `${MARKETING_ASSET_ROOT}/icons/arrow-up.png`
}

export function marketingCarouselArrowLeftIconSrc(): string {
  return `${MARKETING_ASSET_ROOT}/icons/arrow-left-16.png`
}

export function marketingCarouselArrowRightIconSrc(): string {
  return `${MARKETING_ASSET_ROOT}/icons/arrow-right-16.png`
}

export function ivyChatCursorBarSrc(): string {
  return `${MARKETING_ASSET_ROOT}/icons/cursor-bar.png`
}

export function meetIvySpotlightSrc(slug: string): string {
  return `${MARKETING_ASSET_ROOT}/meet-ivy/${slug}.png`
}

/** Large “Podium” wordmark behind the marketing footer (Figma 282:64664). */
export function marketingFooterWatermarkSrc(): string {
  return `${MARKETING_ASSET_ROOT}/footer/podium-watermark.png`
}

/** Press / “As Seen On” logos — reverse (light-on-dark) variants. */
export function marketingPressLogoSrc(slug: string): string {
  return `${MARKETING_ASSET_ROOT}/press/${slug}.svg`
}

export function marketingTestimonialAvatarSrc(slug: string): string {
  return `${MARKETING_ASSET_ROOT}/testimonials/${slug}.webp`
}

export function marketingTestimonialAvatarFallbackSrc(slug: string): string {
  return `${MARKETING_ASSET_ROOT}/testimonials/${slug}.svg`
}
